import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Book from "./pages/Book";
import ChapterReader from "./pages/ChapterReader";
import Chat from "./pages/Chat";
import Course from "./pages/Course";
import CourseVideos from "./pages/CourseVideos";
import Dashboard from "./pages/Dashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import LiveClasses from "./pages/LiveClasses";
import Membership from "./pages/Membership";
import Airlines from "./pages/Airlines";
import Coaching from "./pages/Coaching";
import CoachingSession from "./pages/CoachingSession";
import Reviews from "./pages/Reviews";
import Mentorship from "./pages/Mentorship";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/book" element={<Book />} />
                        <Route path="/book/chapter/:chapterId" element={<ChapterReader />} />
                        <Route path="/chat" element={<Chat />} />
                        <Route path="/course" element={<Course />} />
                        <Route path="/course/videos" element={<CourseVideos />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/payment-success" element={<PaymentSuccess />} />
                        <Route path="/live-classes" element={<LiveClasses />} />
                        <Route path="/community" element={<LiveClasses />} />
                        <Route path="/membership" element={<Membership />} />
                        <Route path="/airlines" element={<Airlines />} />
                        <Route path="/coaching" element={<Coaching />} />
                        <Route path="/coaching/session/:bookingId" element={<CoachingSession />} />
                        <Route path="/reviews" element={<Reviews />} />
                        <Route path="/mentorship" element={<Mentorship />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </Layout>
                <Toaster position="top-right" richColors />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
